import { render, staticRenderFns } from "./MemberDetailDefaultLayout.vue?vue&type=template&id=7327f51f&scoped=true&"
import script from "./MemberDetailDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./MemberDetailDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327f51f",
  null
  
)

export default component.exports